<template>
  <MenuItem :data="diagnosisLists" header="HMI"/>
</template>
<script>
import MenuItem from './components/MenuItem';
import { modelOpenRouter } from '@/mixins/model-open';
import { mapGetters } from 'vuex';
import { allowPartNo, funcOriginalPartNo } from '@/utils/allowPartNo';

export default {
  name: 'DiagnosisHMI',
  mixins: [modelOpenRouter],
  components: {
    MenuItem
  },
  data () {
    return {
      diagnosisList: [
        {
          id: 'diagnosisHmiDisplay',
          img: 'item_part_display.png',
          item: 'Display',
          path: '',
          key: false
        },
        {
          id: 'diagnosisHmiConsole',
          img: 'item_part_console.png',
          item: 'Console',
          path: '',
          key: false
        },
        {
          id: 'diagnosisHmiDisplayConsole',
          img: 'item_part_console_crocoh.png',
          item: 'Console',
          path: '',
          key: true
        },
        {
          id: 'diagnosisBack',
          img: 'item_back.png',
          item: 'Back',
          path: '/service-tools/diagnosis'
        },
        {
          id: 'diagnosisFinishAndCreateReport',
          img: 'item_confirm.png',
          item: 'Finish and Create Report',
          path: 'confirm'
        }
      ]
    };
  },
  mounted () {
    // console.log('<Hmi.vue>',Object.assign({},this.getDeviceInfo))
    // 根據 ConsolePN 指定線條圖
    let diagnosisList = this.diagnosisList;
    for (let i = 0; i < diagnosisList.length; i++) {
      if (diagnosisList[i].item === 'Console') {
        diagnosisList[i].img = this.imgItemPartOfPartNo;
      }
    }
  },
  computed: {
    ...mapGetters({
      getDeviceInfo: 'bikeConnect/getDeviceInfo',
      /**
       * true: 是合在一起
       * false: 是分開
       */
      getDisp: 'diagnosis/getDisp',
      getLcm: 'diagnosis/getLcm'
    }),
    /** 用 ConsolePN 找到對應的圖片 */
    imgOfPartNo () {
      const ConsolePN = funcOriginalPartNo(this.getDeviceInfo.ConsolePN);
      const ConsolePhoto = allowPartNo[ConsolePN].photo;
      return ConsolePhoto;
    },
    /** 用 ConsolePN 找到對應的線條圖 */
    imgItemPartOfPartNo () {
      const ConsolePN = funcOriginalPartNo(this.getDeviceInfo.ConsolePN);
      const ConsolePhoto = allowPartNo[ConsolePN].wiringPhoto;
      return ConsolePhoto;
    },
    diagnosisLists () {
      if (this.getDisp) {
        return this.diagnosisList.filter(item => {
          return item.id !== 'diagnosisHmiDisplay' && item.id !== 'diagnosisHmiConsole';
        });
      } else {
        return this.diagnosisList.filter(item => {
          return item.id !== 'diagnosisHmiDisplayConsole';
        });
      }
    },
    key () {
      if (this.getDisp) return 'together';
      else return 'divide';
    }
  }
};
</script>
